import {
  CHANGE_SEARCH_FIELD,
  SearchActionTypes,
  SET_ROBOT_SET_FIELD,
  RobotSet,
} from "./types";

export const setSearchField: Function = (text: string): SearchActionTypes => ({
  type: CHANGE_SEARCH_FIELD,
  payload: text,
});

export const setRobotSetField = (set: RobotSet): SearchActionTypes => ({
  type: SET_ROBOT_SET_FIELD,
  payload: set,
});
